import Vue from 'vue';
import Vuex from 'vuex';
import { DIALOG_ERROR_CONFIG } from 'store/enums';
import auth from './modules/auth';
import bbva from './modules/bbva';
import offer from './modules/offer';
import operation from './modules/operation';
import ui from './modules/ui';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;

const store = new Vuex.Store({
  state: {
    error: null
  },
  actions: {
    RESET_ERROR_PROPERTY({ commit }) {
      commit('RESET_ERROR_PROPERTY');
    }
  },
  mutations: {
    RESET_ERROR_PROPERTY(state) {
      state.error = null;
    },

    ERROR_OCCURRED(state, error) {
      const { status, data } = error.response || error;
      if (status === 409) {
        // Dialog error message config
        const errorConfig = DIALOG_ERROR_CONFIG[data.idStatus] || DIALOG_ERROR_CONFIG[99];
        errorConfig.description = errorConfig.description || data.desStatus;
        errorConfig.dialog = true;
        if (data.previousGuid) errorConfig.previousGuid = data.previousGuid;
        state.error = errorConfig;
      } else {
        state.error = error;
      }
    }
  },
  modules: {
    auth,
    bbva,
    offer,
    operation,
    ui
  },
  strict: debug
});

export { store as default };
